/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const SvgComponent: FC<IProps> = ({ width = 23, height = 23 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 72 72" fill="none">
    <rect width="72" height="72" rx="36" fill="#F7DC8D"/>
    <path d="M35.9365 54.1875C45.7741 54.1875 53.749 46.2126 53.749 36.375C53.749 26.5374 45.7741 18.5625 35.9365 18.5625C26.0989 18.5625 18.124 26.5374 18.124 36.375C18.124 46.2126 26.0989 54.1875 35.9365 54.1875Z" stroke="#262626" strokeWidth="2.67187" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M35.9375 43.5V36.375" stroke="#262626" strokeWidth="2.67187" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M35.9375 29.25H35.9553" stroke="#262626" strokeWidth="2.67187" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default SvgComponent;
